const getters = {
  qccData: state => state.qcc.qccData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js